import { createSlice } from '@reduxjs/toolkit';
import REST_API from '../../../services/APIRoutes';

const INIT_STATE = {
  message: { type: '', text: '' },
  navCollapsed: true,
  width: window.innerWidth,
  height: window.innerHeight,
  pathname: '/',
}

export const commonSlice = createSlice({
  name: 'common',
  initialState: INIT_STATE,
  reducers: {
    updateWindowSize: (state, { payload }) => ({ ...state, ...payload }),
    showMessage: (state, { payload }) => ({ ...state, message: payload }),
    hideMessage: (state) => ({ ...state, message: { type: '', text: '' } }),
    toggleCollapsedSideNav: (state, { payload }) => ({
      ...state,
      navCollapsed: payload,
    }),
    addCommonItems: (state, { payload }) => ({
      ...state,
      [payload.key]: payload.value,
    }),
    clearDiscount: (state) => {
      const newState = { ...state };
      delete newState[`${REST_API.DISCOUNT}_`];
      return newState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('@@router/LOCATION_CHANGE', (state, action) => ({
      ...state,
      pathname: action.payload.location.pathname,
      navCollapsed: false,
    }))
  },
})

export const {
  showMessage,
  hideMessage,
  updateWindowSize,
  toggleCollapsedSideNav,
  addCommonItems,
  clearDiscount,
} = commonSlice.actions

export default commonSlice.reducer
